export let formGroup = {
    medicalPatient: 'vte',
    surgicalPatient: 'vte',
    orthopaedicPatient: 'vte',
    lowerLimb: 'thromboembolism',
    footAnkle: 'thromboembolism',
};

export let VteGroupsSettings = {
    vte: {
        staticOutcomeWarning: 'Low Molecular Weight Heparin is a porcine-derived product. Some patients may have religious or other objections to receiving porcine derivatives. Please consider whether this applies to your patient – for further information on alternatives please contact Clinical Haematology or your ward pharmacist',
        components: [
            {
                label: 'Assessments',
                set: 'assessments',
            },
            {
                label: 'Bleeding Risk',
                set: 'bleedingRisk',
            },
        ],
    },
    thromboembolism: {
        staticOutcomeWarning: 'If yes to any risk factors patient should be offered VTE prophylaxis with low molecular weight heparin (e.g.\n' +
            'enoxaparin 40mg s/c daily) unless contraindications exist.',

        components: [
            {
                label: 'Risk Factors',
                set: 'riskFactors',
            },
            {
                label: 'Contraindications',
                set: 'contraindications',
            },
            {
                label: 'Questions',
                saveAllValues: true,
                set: 'other',
            },
        ],
    },
};

export let vteQuestions = {
    totalAnaesthetic: {
        text: 'Surgical procedure with a total anaesthetic and surgical time of more than 90 minutes, or 60 minutes if the surgery involves the pelvis or lower limb',
        actions: {
            visibleOnyIfTypeIs: ['surgicalPatient'],
        },
    },
    admissionInflammatory: {
        text: 'Acute surgical admission with inflammatory or intra-abdominal condition',
        actions: {
            visibleOnyIfTypeIs: ['surgicalPatient'],
        },
    },
    significantlyReducedMobility: {
        text: 'Patient expected to have significantly reduced mobility for 3 days or more',
        actions: {
            visibleOnyIfTypeIs: ['medicalPatient', 'surgicalPatient'],
        },
    },
    cancer: {
        text: 'Active cancer or cancer treatment',
        actions: {
            visibleOnyIfTypeIs: ['medicalPatient'],
        },
    },
    daySurgery: {
        text: 'Day Surgery Patient',
        actions: {
            visibleOnyIfSubTypeIs: 'OO',
            visibleOnyIfTypeIs: ['surgicalPatient'],
        },
    },
    reducedMobility: {
        text: 'Expected significant reduction in mobility following discharge',
        actions: {
            visibleOnyIfValueIsTrue: 'daySurgery',
        },
    },
    age: {
        text: 'Age over 60 years',
        actions: {
            valueFromFunction: 'patientOver60',
        },
    },
    criticalAdmission: {
        text: 'Critical Care Admission',
    },
    dehydration: {
        text: 'Dehydration',
    },
    bloodLossTransfusion: {
        text: 'Excess blood loss or blood transfusion',
    },
    thrombophilia: {
        text: 'Known thrombophilia',
    },
    obesity: {
        text: 'Obesity (BMI >30 kg/m2)',
    },
    medicalComorbidities: {
        text: 'One or more significant medical comorbidities (e.g. heart disease; metabolic, endocrine or respiratory pathology; acute infectious diseases; inflammatory conditions)',
    },
    historyVTE: {
        text: 'Personal history or first degree relative with a history of VTE',
    },
    hormoneTherapy: {
        text: 'Use of hormone replacement therapy',
    },
    oestrogenContaining: {
        text: 'Use of oestrogen-containing contraceptive therapy',
    },
    varicose: {
        text: 'Varicose veins with phlebitis',
    },
};
export let vteValues = {
    assessments: {
        totalAnaesthetic: false,
        admissionInflammatory: false,
        daySurgery: false,
        reducedMobility: false,
        significantlyReducedMobility: false,
        cancer: false,
        age: false,
        criticalAdmission: false,
        dehydration: false,
        bloodLossTransfusion: false,
        thrombophilia: false,
        obesity: false,
        medicalComorbidities: false,
        historyVTE: false,
        hormoneTherapy: false,
        oestrogenContaining: false,
        varicose: false,
    },
    bleedingRisk: {
        acuteStroke: false,
        patientImmobile: false,
        activeBleeding: false,
        acquiredBleeding: false,
        useAnticoagulants: false,
        lumbar12Hours: false,
        lumbar4Hours: false,
        thrombocytopenia: false,
        hypertension: false,
        bleedingDisorder: false,
        neurosurgery: false,
        otherProcedure: false,
    },
};

export let bleedingRiskQuestions = {
    acuteStroke: {
        text: 'Acute stroke',
        outcome: 'O100',
    },
    patientImmobile: {
        text: 'The patient is immobile (unable to walk to the toilet unaided)',
        outcome: 'O110',
        actions: {
            visibleOnyIfValueIsTrue: 'acuteStroke',
        },
    },
    activeBleeding: {
        text: 'Active bleeding',
        outcome: 'D',
    },
    acquiredBleeding: {
        text: 'Acquired bleeding disorder (such as acute liver failure)',
        outcome: 'D',
    },
    useAnticoagulants: {
        text: 'Concurrent use of anticoagulants known to increase the risk of bleeding (such as warfarin with international normalised\n' +
            'ratio (INR) higher than 2.0, Dabigatran, Apixaban, Rivaroxaban, Edoxaban, Fondaparinux or Therapeutic Low Molecular\n' +
            'Weight Heparin)',
        outcome: 'O90',
    },
    lumbar12Hours: {
        text: 'Lumbar puncture/epidural/spinal anaesthesia expected within the next 12 hours',
        outcome: 'D',
    },
    lumbar4Hours: {
        text: 'Lumbar puncture/epidural/spinal anaesthesia within the previous 4 hours',
        outcome: 'D',
    },
    thrombocytopenia: {
        text: 'Thrombocytopenia (platelets less than 75 x 1049/L)',
        outcome: 'D',
    },
    hypertension: {
        text: 'Uncontrolled systolic hypertension (230/120 mmHg or higher)',
        outcome: 'D',
    },
    bleedingDisorder: {
        text: 'Untreated inherited bleeding disorder (such as haemophilia or von Willebrand\'s disease)',
        outcome: 'D',
    },
    neurosurgery: {
        text: 'Neurosurgery, spinal surgery or eye surgery',
        outcome: 'D',
    },
    otherProcedure: {
        text: 'Other procedure with high bleeding risk',
        outcome: 'D',
    },
};

export let limbPatientValuesQuestions = {
    anticoagulantTherapy: {
        text: 'Anticoagulant therapy',
        outcome: 'C',
        actions: {
            visibleOnyIfTypeIs: ['lowerLimb'],
        },
    },
    haemophilia: {
        text: 'Haemophilia/ other haemorrhagic disorder',
        outcome: 'C',
    },
    thrombocytopaenia: {
        text: 'Thrombocytopenia or previous heparin induced thrombocytopaenia',
        outcome: 'C',
    },
    recentHaemorrhage: {
        text: 'Recent cerebral haemorrhage or severe hypertension (SBP >180 or DBP>110)',
        outcome: 'C',
    },
    activePeptic: {
        text: 'Active peptic ulcer or recent Gl bleed',
        outcome: 'C',
    },
    majorTrauma: {
        text: 'Recent (within one week) major trauma / surgery to eye or nervous system',
        outcome: 'C',
    },
    allergy: {
        text: 'Allergy/ hypersensitivity to heparin',
        outcome: 'C',
    },
    riskDeemed: {
        text: 'Risks deemed to outweigh benefits by clinician please document in notes',
        outcome: 'C',
    },
    kidneyDisease: {
        text: 'Moderate/ severe kidney disease eGFR <30ml/min (eGFR 30 50ml/ min use reduced dose LMWH)',
        outcome: 'C',
    },
};
export let limbPatientQuestions = {
    trauma: {
        text: 'Lower limb trauma such as ankle & foot fractures',
    },
    immobilised: {
        text: 'Immobilised in non-weight bearing cast or boot',
        actions: {
            visibleOnyIfTypeIs: ['lowerLimb'],
        },
    },
    achillesSurgery: {
        text: 'Achilles tendon rupture or surgery',
    },
    ageOver60: {
        text: 'Age > 60 years',
        actions: {
            valueFromFunction: 'patientOver60',
        },
    },
    currentHormoneTherapy: {
        text: 'Current hormone therapy (HRT/ tamoxifen/ ostrogen containing OCP)',
    },
    personalVteHistory: {
        text: 'Personal or first degree relative VTE history',
    },
    smoker: {
        text: 'Active smoker',
    },
    pregnancy: {
        text: 'Pregnancy/ post-partum (within 2 weeks)',
    },
    COPD: {
        text: 'Serious comorbidity including heart failure/ COPD/ CKD/ inflammatory bowel disease',
    },
    obesity: {
        text: 'Obesity (BMI >30)',
    },
    varicoseVeins: {
        text: 'Extensive varicose veins',
    },
    recentAdmission: {
        text: 'Recent hospital admission (within one week)/ major surgery (within 4 weeks)',
    },
    cancer: {
        text: 'Active cancer',
    },
    thrombophilia: {
        text: 'Known thrombophilia',
    },
};
export let limbPatientOtherQuestions = {
    explanationOfSigns: {
        text: 'Explanation of signs & symptoms of VTE to patient?',
        outcome: 'X',
    },
    adviceProvided: {
        text: ' Advice provided on actions if concerned that they are developing VTE?',
        outcome: 'X',
    },
};

export let LimbPatientValues = {
    riskFactors: {
        trauma: false,
        immobilised: false,
        achillesSurgery: false,
        ageOver60: false,
        currentHormoneTherapy: false,
        personalVteHistory: false,
        smoker: false,
        pregnancy: false,
        COPD: false,
        obesity: false,
        varicoseVeins: false,
        recentAdmission: false,
        cancer: false,
        thrombophilia: false,
    },
    contraindications: {
        anticoagulantTherapy: false,
        haemophilia: false,
        thrombocytopaenia: false,
        recentHaemorrhage: false,
        activePeptic: false,
        majorTrauma: false,
        allergy: false,
        riskDeemed: false,
        kidneyDisease: false,
    },
    other: {
        explanationOfSigns: false,
        adviceProvided: false,
    },
};

export let mappers = {
    medicalPatient: {
        outcome: 'A',
        map: {OA: 0, A: 1},
    },
    surgicalPatient: {
        outcome: 'B',
        map: {OB: 0, B: 1, OB_DS: 2, B_DS: 3, OB_DS_RM: 4, B_DS_RM: 5},
        fieldToCheck: [
            {
                field: 'daySurgery',
                value: 'DS',
            },
            {
                field: 'reducedMobility',
                value: 'RM',
            },
        ],
    },
    orthopaedicPatient: {
        outcome: 'C',
        fieldToCheck: [
            {
                field: 'daySurgery',
                value: 'DS',
            },
            {
                field: 'reducedMobility',
                value: 'RM',
            },
        ],
        map: {
            OC_EK: 0,
            C_EK: 1,
            OC_EH: 2,
            C_EH: 3,
            OC_HF: 4,
            C_HF: 5,
            OC_OO: 6,
            C_OO: 7,
            OC_OO_DS: 8,
            C_OO_DS: 9,
            OC_OO_DS_RM: 10,
            C_OO_DS_RM: 11,
        },
    },

    lowerLimb: {
        outcome: 'C',
        map: {OC: 0, C: 1},
    },
    footAnkle: {
        outcome: 'C',
        map: {OC: 0, C: 1},
    },
    bleedingRiskMap: {
        map: {D: 1, O90: 2, O100: 3, O110: 4},
    },
    contraindicationsRiskMap: {
        map: {C: 1},
    },

};

export let outcomes = {
    medicalPatient: [
        [4, 6, 3, 2, 1],
        [5, 7, 3, 2, 1],
    ],
    surgicalPatient: [
        [8, 10, 3, 2, 1],
        [9, 11, 3, 2, 1],
        [12, 14, 3, 2, 1],
        [13, 15, 3, 2, 1],
        [16, 18, 3, 2, 1],
        [17, 19, 3, 2, 1],
    ],
    orthopaedicPatient: [
        [20, 22, 3, 2, 1],
        [21, 23, 3, 2, 1],
        [24, 26, 3, 2, 1],
        [25, 27, 3, 2, 1],
        [28, 30, 3, 2, 1],
        [29, 31, 3, 2, 1],
        [32, 34, 3, 2, 1],
        [33, 35, 3, 2, 1],
        [36, 38, 3, 2, 1],
        [37, 39, 3, 2, 1],
        [40, 42, 3, 2, 1],
        [41, 43, 3, 2, 1],
    ],
    lowerLimb: [
        [44, 45],
        [46, 47],
    ],
    footAnkle: [
        [44, 45],
        [46, 47],
    ],
};

export let outcomesTexts = [
    '',
    'Stroke patient with reduced mobility. Offer Intermittent Pneumatic Compression Devices unless contraindicated. Do not routinely offer pharmacological thromboprophylaxis Continue to reassess risk factors.',
    'Stroke Patient without reduced mobility. Do not routinely offer pharmacological or mechanical thromboprophylaxis. Continue to reassess risk factors.',
    'Patient already anticoagulated – do not routinely offer additional pharmacological or mechanical thromboprophylaxis provided this is continued and remains therapeutic. Reassess risk if anticoagulant discontinued or falls below therapeutic threshold.',
    'Medical patient not at increased risk of thrombosis or bleeding. Do not routinely offer pharmacological or mechanical thromboprophylaxis. Reassess risk if the clinical condition changes',
    'Medical Patient at increased Thrombotic Risk. Offer Pharmacological Thromboprophylaxis.',
    'Medical Patient at increased bleeding risk and not at increased thrombotic risk. Reassess risk if the clinical condition changes.',
    'Medical Patient at Increased Thrombotic and Increased Bleeding Risk. Offer Mechanical Thromboprophylaxis unless contraindicated. Do not routinely offer pharmacological thromboprophylaxis due to bleeding risk. Continue to reassess risk.',
    'Surgical Patient low thrombotic and bleeding risk. Offer Mechanical Thromboprophylaxis and Pharmacological thromboprophylaxis.',
    'Surgical Patient at increased thrombotic risk and low bleeding risk. Offer Mechanical Thromboprophylaxis from admission and pharmacological thromboprophylaxis. Extend pharmacological thromboprophylaxis for at least 28 days post-op if major cancer surgery to the abdomen or pelvis.',
    'Surgical Patient at low thrombotic and bleeding risk. Offer Mechanical Thromboprophylaxis from admission. Do not routinely offer pharmacological thromboprophylaxis. Reassess risk if the clinical condition changes.',
    'Surgical Patient at increased Thrombotic Risk and Increased Bleeding Risk. Offer Mechanical Thromboprophylaxis from admission. Do not routinely offer pharmacological thromboprophylaxis due to increased bleeding risk. Rassess risk if the clinical condition changes.',
    'Surgical Daycase Patient expected to have reduced mobility and low bleeding risk. Offer Mechanical Thromboprophylaxis from admission. Offer pharmacological thromboprophylaxis for patients at low risk of major bleeding.',
    'Surgical Daycase Patient at increased thrombotic risk and low bleeding risk. Offer Mechanical Thromboprophylaxis from admission. Offer pharmacological thromboprophylaxis for patients at low risk of major bleeding depending on clinical judgement.',
    'Surgical Daycase Patient expected to have reduced mobility and low bleeding risk. Offer Mechanical Thromboprophylaxis from admission. Do not offer pharmacological thromboprophylaxis due to increased bleeding risk. Reassess risk if the clinical condition changes.',
    'Surgical Daycase Patient at increased Thrombotic Risk and Increased Bleeding Risk. Offer Mechanical Thromboprophylaxis from admission. Do not routinely offer pharmacological thromboprophylaxis due to increased bleeding risk. Reassess risk if the clinical condition changes.',
    'Surgical Daycase Patient expected to have reduced mobility and low bleeding risk. Offer Mechanical Thromboprophylaxis from admission and continue until mobility no longer significantly reduced. Offer pharmacological thromboprophylaxis for patients at low risk of major bleeding depending on clinical judgement, and continue until mobility no longer significantly reduced (usually 5-7 days)',
    'Surgical Daycase Patient at increased thrombotic risk and low bleeding risk. Offer Mechanical Thromboprophylaxis from admission and continue until mobility no longer significanlty reduced. Offer pharmacological thromboprophylaxis for patients at low risk of major bleeding depending on clinical judgement, and continue until mobility no longer significantly reduced (usually 5-7 days)',
    'Surgical Daycase Patient expected to have reduced mobility and low bleeding risk. Offer Mechanical Thromboprophylaxis from admission and continue until mobility no longer significantly reduced. Do not offer pharmacological thromboprophylaxis due to increased bleeding risk. Reassess risk if the clinical condition changes.',
    'Surgical Daycase Patient at increased Thrombotic Risk and Increased Bleeding Risk. Offer Mechanical Thromboprophylaxis from admission. Do not routinely offer pharmacological thromboprophylaxis due to increased bleeding risk. Reassess risk if the clinical condition changes.',
    'Elective Knee Replacement Patient. Start Mechanical Thromboprophylaxis from admission unless contraindicated and pharmacological thromboprophylaxis with Low Molecular Weight Heparin 6-12 hours post-op. Continue Low Molecular Weight Heparin for at least 10 days.',
    'Elective Knee Replacement Patient. Start Mechanical Thromboprophylaxis from admission unless contraindicated and pharmacological thromboprophylaxis with Low Molecular Weight Heparin 6-12 hours post-op. Continue Low Molecular Weight Heparin for at least 10 days.',
    'Elective Knee Replacement Patient at increased risk of bleeding. Start mechanical thromboprophylaxis from admission unless contraindicated and discuss pharmacological thromboprophylaxis with the VTE Prevention Team/Haematology. Continue to reassess risk.',
    'Elective Knee Replacement Patient at increased risk of bleeding. Start mechanical thromboprophylaxis from admission unless contraindicated and discuss pharmacological thromboprophylaxis with the VTE Prevention Team/Haematology. Continue to reassess risk.',
    'Elective Hip Replacement Patient. Start Mechanical Thromboprophylaxis from admission unless contraindicated and pharmacological thromboprophylaxis with Low Molecular Weight Heparin 6-12 hours post-op. Continue Low Molecular Weight Heparin for at least 28 days.',
    'Elective Hip Replacement Patient. Start Mechanical Thromboprophylaxis from admission unless contraindicated and pharmacological thromboprophylaxis with Low Molecular Weight Heparin 6-12 hours post-op. Continue Low Molecular Weight Heparin for at least 28 days.',
    'Elective Hip Replacement Patient at increased risk of bleeding. Start mechanical thromboprophylaxis from admission unless contraindicated and discuss pharmacological thromboprophylaxis with the VTE Prevention Team/Haematology. Continue to reassess risk.',
    'Elective Hip Replacement Patient at increased risk of bleeding. Start mechanical thromboprophylaxis from admission unless contraindicated and discuss pharmacological thromboprophylaxis with the VTE Prevention Team/Haematology. Continue to reassess risk.',
    'Hip Fracture Patient. Start Mechanical Thromboprophylaxis from admission and pharmacological thromboprophylaxis with Low Molecular Weight Heparin. Stop Low Molecular Weight Heparin 12 hours pre-op and restart 6-12 hours post-op. Continue Low Molecular Weight Heparin for at least 30 days.',
    'Hip Fracture Patient. Start Mechanical Thromboprophylaxis from admission and pharmacological thromboprophylaxis with Low Molecular Weight Heparin. Stop Low Molecular Weight Heparin 12 hours pre-op and restart 6-12 hours post-op. Continue Low Molecular Weight Heparin for at least 30 days.',
    'Hip Fracture Patient at increased risk of bleeding. Start mechanical thromboprophylaxis from admission unless contraindicated and discuss pharmacological thromboprophylaxis with the VTE Team/Haematology. Continue to reassess risk.',
    'Hip Fracture Patient at increased risk of bleeding. Start mechanical thromboprophylaxis from admission unless contraindicated and discuss pharmacological thromboprophylaxis with the VTE Team/Haematology. Continue to reassess risk.',
    'Orthopaedic Patient low thrombotic and bleeding risk. Offer Mechanical Thromboprophylaxis and Pharmacological thromboprophylaxis.',
    'Orthopaedic Patient at increased thrombotic risk and low bleeding risk. Offer Mechanical Thromboprophylaxis from admission and pharmacological thromboprophylaxis.',
    'Orthopaedic Patient at low thrombotic and bleeding risk. Offer Mechanical Thromboprophylaxis from admission. Do not routinely offer pharmacological thromboprophylaxis. Reassess risk if the clinical condition changes.',
    'Orthopaedic Patient at increased Thrombotic Risk and Increased Bleeding Risk. Offer Mechanical Thromboprophylaxis from admission. Do not routinely offer pharmacological thromboprophylaxis due to increased bleeding risk. Reassess risk if the clinical condition changes.',
    'Orthopaedic Daycase Patient expected to have reduced mobility and low bleeding risk. Offer Mechanical Thromboprophylaxis from admission. Offer pharmacological thromboprophylaxis for patients at low risk of major bleeding.',
    'Orthopaedic Daycase Patient at increased thrombotic risk and low bleeding risk. Offer Mechanical Thromboprophylaxis from admission. Offer pharmacological thromboprophylaxis for patients at low risk of major bleeding depending on clinical judgement.',
    'Orthopaedic Daycase Patient expected to have reduced mobility and low bleeding risk. Offer Mechanical Thromboprophylaxis from admission. Do not offer pharmacological thromboprophylaxis due to increased bleeding risk. Reassess risk if the clinical condition changes.',
    'Orthopaedic Daycase Patient at increased Thrombotic Risk and Increased Bleeding Risk. Offer Mechanical Thromboprophylaxis from admission. Do not routinely offer pharmacological thromboprophylaxis due to increased bleeding risk. Reassess risk if the clinical condition changes.',
    'Orthopaedic Daycase Patient expected to have reduced mobility and low bleeding risk. Offer Mechanical Thromboprophylaxis from admission and continue until mobility no longer significantly reduced. Offer pharmacological thromboprophylaxis for patients at low risk of major bleeding depending on clinical judgement and continue until mobility no longer significantly reduced (usually 5-7 days).',
    'Orthopaedic Daycase Patient at increased thrombotic risk and low bleeding risk. Offer Mechanical Thromboprophylaxis from admission and continue until mobility no longer significantly reduced. Offer pharmacological thromboprophylaxis or patients at low risk of major bleeding depending on clinical judgement, and continue until mobility no longer significantly reduced (usually 5-7 days).',
    'Orthopaedic Daycase Patient expected to have reduced mobility and low bleeding risk. Offer Mechanical Thromboprophylaxis from admission and continue until mobility no longer significantly reduced. Do not offer pharmacological thromboprophylaxis due to increased bleeding risk. Reassess risk if the clinical condition changes.',
    'Orthopaedic Daycase Patient at increased Thrombotic Risk and Increased Bleeding Risk. Offer Mechanical Thromboprophylaxis from admission. Do not routinely offer pharmacological thromboprophylaxis due to increased bleeding risk. Reassess risk if the clinical condition changes.',
    'No Risk Factor, No Contraindications',
    'No Risk Factor, Contraindications exist',
    'Risk Factors exist, No Contraindications',
    'Risk Factors exist, Contraindications exist',
];

export const getFullFormName = (type) => {
    let name = '';
    switch (type) {
        case 'medicalPatient':
            name = 'Medical Patient';
            break;
        case 'surgicalPatient':
            name = 'Surgical Patient';
            break;
        case 'orthopaedicPatient':
            name = 'Orthopaedic Patient';
            break;
        case 'lowerLimb':
            name = 'Lower limb/foot & ankle venous thromboembolism (VTE) prophylaxis. For all adult patients (>18yrs) with lower limb injury or surgery with an anticipated reduction in mobility.';
            break;
        case 'footAnkle':
            name = 'FOOT & ANKLE VENOUS THROMOBOEMBOLISM (VTE) PROPHYLAXIS PROFORMA';
            break;
        default:
            break;
    }
    return name;
};